export default function WhyChooseUs() {
  const benefits = [
    'Customized Growth Strategies',
    'Transparent Reporting & Communication',
    'Data-Backed Decision Making',
    'Consistent Optimization & Testing',
    'Dedicated Support Team'
  ];

  return (
    <section id="why-us" className="py-32 bg-[#1A1A1A]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          {/* Left Column */}
          <div className="lg:col-span-2">
            <p className="text-[#FF6B35] text-sm font-semibold tracking-[0.2em] uppercase mb-6">
              WHY ESCOBAR
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-8">
              Results-Driven Marketing That Actually Works
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              We don't chase vanity metrics. Every strategy is built around your revenue goals, backed by data, and optimized for maximum ROI.
            </p>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-3 flex flex-col gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-[#2A2A2A] rounded-xl p-6 flex items-center gap-6 hover:bg-[#333333] transition-all duration-300 cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-check-line text-white text-2xl"></i>
                </div>
                <p className="text-white text-xl font-medium">
                  {benefit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
